import App from '../src/components/layouts/App';
import MentorsList from '../src/components/MentorsList/MentorsList';

function HomePage() {
  return (
    <App>
      <MentorsList />
    </App>
  );
}

export default HomePage;
